import { render, staticRenderFns } from "./ListagemCollapsesPedidos.vue?vue&type=template&id=0ed9ce5f&scoped=true"
import script from "./ListagemCollapsesPedidos.vue?vue&type=script&lang=js"
export * from "./ListagemCollapsesPedidos.vue?vue&type=script&lang=js"
import style0 from "./ListagemCollapsesPedidos.vue?vue&type=style&index=0&id=0ed9ce5f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9ce5f",
  null
  
)

export default component.exports